export const SET_FETCHING_ROUNDS = 'SET_FETCHING_ROUNDS';
export const GET_GROUP_ROUNDS_SUCCESS = 'GET_GROUP_ROUNDS_SUCCESS';